var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup264(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(-221 -3076)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_106",
    "data-name": "Ellipse 106",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(221 3076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M9.333,1.659a28.618,28.618,0,0,1,3.733.1,4.81,4.81,0,0,1,1.763.311,3.642,3.642,0,0,1,1.763,1.763A4.81,4.81,0,0,1,16.9,5.6c0,.933.1,1.244.1,3.733a28.618,28.618,0,0,1-.1,3.733,4.81,4.81,0,0,1-.311,1.763,3.642,3.642,0,0,1-1.763,1.763,4.81,4.81,0,0,1-1.763.311c-.933,0-1.244.1-3.733.1A28.618,28.618,0,0,1,5.6,16.9a4.81,4.81,0,0,1-1.763-.311A3.642,3.642,0,0,1,2.074,14.83a4.81,4.81,0,0,1-.311-1.763c0-.933-.1-1.244-.1-3.733a28.618,28.618,0,0,1,.1-3.733,4.81,4.81,0,0,1,.311-1.763A3.725,3.725,0,0,1,2.8,2.8a1.753,1.753,0,0,1,1.037-.726A4.81,4.81,0,0,1,5.6,1.763a28.618,28.618,0,0,1,3.733-.1M9.333,0A30.642,30.642,0,0,0,5.5.1,6.4,6.4,0,0,0,3.215.519,4.06,4.06,0,0,0,1.556,1.556,4.06,4.06,0,0,0,.519,3.215,4.725,4.725,0,0,0,.1,5.5,30.642,30.642,0,0,0,0,9.333,30.642,30.642,0,0,0,.1,13.17a6.4,6.4,0,0,0,.415,2.281,4.06,4.06,0,0,0,1.037,1.659,4.06,4.06,0,0,0,1.659,1.037,6.4,6.4,0,0,0,2.281.415,30.641,30.641,0,0,0,3.837.1,30.641,30.641,0,0,0,3.837-.1,6.4,6.4,0,0,0,2.281-.415,4.351,4.351,0,0,0,2.7-2.7,6.4,6.4,0,0,0,.415-2.281c0-1.037.1-1.348.1-3.837a30.641,30.641,0,0,0-.1-3.837,6.4,6.4,0,0,0-.415-2.281,4.06,4.06,0,0,0-1.037-1.659A4.06,4.06,0,0,0,15.452.519,6.4,6.4,0,0,0,13.17.1,30.642,30.642,0,0,0,9.333,0m0,4.563a4.694,4.694,0,0,0-4.77,4.77,4.77,4.77,0,1,0,4.77-4.77m0,7.881A3.056,3.056,0,0,1,6.222,9.333,3.056,3.056,0,0,1,9.333,6.222a3.056,3.056,0,0,1,3.111,3.111,3.056,3.056,0,0,1-3.111,3.111m4.978-9.23a1.141,1.141,0,1,0,1.141,1.141,1.151,1.151,0,0,0-1.141-1.141",
    transform: "translate(228.389 3083.167)",
    fill: "#123374",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup264);
export default __webpack_public_path__ + "static/media/Group 264.3dfc74903aa93b8d048283de2672e1f6.svg";
export { ForwardRef as ReactComponent };